module.exports = __webpack_public_path__ + "img/disclosure-indicator.03ce493e.svg";